import { makeStyles } from '@material-ui/core';

const useLogoutStyles = makeStyles(() => ({
  button: {
    display: 'flex',
    color: '#007DB8',
    lineHeight: '55px',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textTransform: 'capitalize',
    paddingLeft: '16px',
    fontWeight: 400
  },
  logoutBtnText: {
    color: 'var(--primary-primary-500, #007DB8)',
    fontWeight: 500,
    fontFamily: 'Roboto',
    fontSize: '14px',
    lineHeight: '20px',
    fontStyle: "normal"
  },  
  icon: {
    width: 'var(--menu-link-icon-dim)',
    height: 'var(--menu-link-icon-dim)',
    color: 'var(--cerulean)',
    marginLeft: '15px',
    '& > g, & > path': {
      strokeWidth: '1.75'
    }
  },
  btn_primary: {
    color: 'var(--white)',
    backgroundColor: 'var(--teal-blue)',
    '&:hover': {
      color: 'var(--white)',
      backgroundColor: 'var(--teal-blue)',
    }
  },
  titleIcon: {
    color: 'var(--warning-orange)',
    verticalAlign: "bottom"
  }
}));

export default useLogoutStyles;
